export default __webpack_public_path__ + "static/media/item5@2x.9eae9ea9.png";